import { MLink } from "@/lib/marketing/m-link";

export function BrandMark({ testId = "link-home" }: { testId?: string }) {
  return (
    <MLink href="/">
      {/* The wordmark is the mark: live text in the page's face so the logotype cannot drift when
          the type scale moves. The tracking is the brand's; the color is this surface's own ink,
          right on /v2's dark ground. */}
      <div className="cursor-pointer" data-testid={testId}>
        {/* Letter-spacing this wide makes some screen readers spell the word
            out a letter at a time, so the letterforms are decoration and the
            name is carried by the text beside them. */}
        <span
          aria-hidden="true"
          className="block py-1.5 text-[1.06rem] font-semibold leading-none tracking-[0.04em] text-foreground"
        >
          PPL
        </span>
        {/* The letterforms stay PPL; the long form is the name a crawler reads. */}
        <span className="sr-only" data-testid="text-brand">
          PEOPLE AI Workforce
        </span>
      </div>
    </MLink>
  );
}
